import React from 'react';
import { ClipboardCheckIcon, Clock3Icon } from 'lucide-react';
import { SectionReveal } from './SectionReveal';
const valueCards = [{
  icon: Clock3Icon,
  eyebrow: 'SOLUCIÓN 01',
  title: 'Dejá de regalarle horas a ARCA.',
  description: 'Sistematizá la carga administrativa del nuevo régimen. Resolvé el Encuadre y la Notificación sin cargar datos manualmente ni volver a empezar con cada sujeto obligado.',
  accent: 'text-accent',
  surface: 'border-accent/25 bg-accent/5'
}, {
  icon: ClipboardCheckIcon,
  eyebrow: 'SOLUCIÓN 02',
  title: 'Todo sobre la RG 5866.',
  description: 'Implementación completa para directores de SA, gerentes de SRL, abogados y colegios privados. Con todos los plazos de septiembre a diciembre en un solo lugar.',
  accent: 'text-blue',
  surface: 'border-blue/25 bg-blue/5'
}];
export function CoreValueProposition() {
  return <section className="w-full bg-alt" data-id="element-16" data-mp="288253g7p8r0x">
      <div className="mx-auto max-w-5xl px-5 py-14 md:py-20" data-id="element-17" data-mp="284wefwjf9h33">
        <SectionReveal className="mx-auto max-w-2xl text-center" data-id="element-18" data-mp="3roug7qznp30z">
          <p className="text-xs font-bold uppercase tracking-badge text-blue" data-id="element-19" data-mp="jb9z3gf5vyv">
            Dos resultados concretos
          </p>
          <h2 className="mt-3 text-2xl font-black leading-tight text-ink sm:text-3xl" data-id="element-20" data-mp="3iq92qa91ke72">
            Menos carga operativa. Más control sobre tu cartera.
          </h2>
        </SectionReveal>

        <div className="mt-8 grid gap-5 md:grid-cols-2" data-id="element-21" data-mp="eapujepz6581">
          {valueCards.map(({
          icon: Icon,
          eyebrow,
          title,
          description,
          accent,
          surface
        }, index) => <SectionReveal key={title} delay={index * 0.1} data-id="element-22" data-mp="5hw6arsjvvi1" data-mpi={index}>
                <article className={`h-full rounded-2xl border p-6 shadow-sm sm:p-7 ${surface}`} data-id="element-23" data-mp="9jr8dyib2cwv">
                  <span className={`flex h-11 w-11 items-center justify-center rounded-xl bg-base shadow-sm ${accent}`} data-id="element-24" data-mp="x923p0gvzf3m">
                    <Icon className="h-5 w-5" strokeWidth={2.25} data-id="element-25" data-mp="1bwalwl8m4kp3" />
                  </span>
                  <p className={`mt-5 text-xs font-bold uppercase tracking-badge ${accent}`} data-id="element-26" data-mp="17v8gfmo3rceo">
                    {eyebrow}
                  </p>
                  <h3 className="mt-2 text-xl font-black leading-tight text-ink" data-id="element-27" data-mp="12xp4wuishdqf">
                    {title}
                  </h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-28" data-mp="sxy8gnao4onp">
                    {description}
                  </p>
                </article>
              </SectionReveal>)}
        </div>
      </div>
    </section>;
}